import { BackButtonStyles as S } from '~/app/components/BackButton/styles'
import arrowSvg from '~/assets/images/arrow.svg'
import { appHistory } from '~/shared/utils'

type Props = { className?: string }

const BackButton = ({ className }: Props) => (
  <S.Root className={className} onClick={() => appHistory.goBack()}>
    <img src={arrowSvg} alt="back arrow" />
  </S.Root>
)

export default BackButton
